<template>
  <pt-report :data="data" :loaded="loaded" :loadErr="loadErr"></pt-report>
</template>
<script>
import ptReport from "./index";
export default {
  components: {
    ptReport,
  },
  computed: {
    reportDataId() {
      return this.$route.query.reportDataId;
    },
  },
  data() {
    return {
      data: {},
      loading: false,
      loaded: false,
      loadErr: false,
    };
  },
  methods: {
    getReportMessage() {
      this.loading = true;
      this.$store
        .dispatch("getReportMessage", this.reportDataId)
        .then((res) => {
          this.data = res;
          this.loading = false;
          this.loaded = true;
        })
        .catch((err) => {
          this.loading = false;
          this.loadErr = true;
        });
    },
  },
  created() {
    this.getReportMessage();
  },
};
</script>
